import type {ReactElement} from 'react';
import React from 'react';
import {PosterMobileBigSeekbar} from '@Components/poster-editor/components/poster-mobile-big-seekbar';
import {POSTER_MOBILE_BIG_SEEK_BAR_HEIGHT} from '@Components/poster-editor/components/poster-mobile-big-seekbar/poster-mobile-big-seekbar.types';
import {useAppSelector} from '@/hooks';
import {isScaleAnimatingToFitToScreen} from '../../poster-editor-reducer';
import {useIsVideoOrHasMultiPages} from '@Hooks/poster-editor/useIsVideoOrHasMultiPages';

export function PostPosterElement(): ReactElement<any> | null {
  const isScaleAnimatingToFit = useAppSelector(isScaleAnimatingToFitToScreen);
  const isMobileVariant =
    useAppSelector((state) => {
      return state.posterEditor.isMobileVariant;
    }) || false;
  const canvasHeight = useAppSelector((state) => {
    return state.posterEditor.canvasDimensions.height;
  });
  const whiteboardContainerHeight = useAppSelector((state) => {
    return state.posterEditor.whiteboardContainerDimensions.height;
  });
  const isPosterVideo = useIsVideoOrHasMultiPages();
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });

  const hidePosterMobileBigSeekbar = (): boolean => {
    if (isScaleAnimatingToFit) {
      return false;
    }

    return canvasHeight + POSTER_MOBILE_BIG_SEEK_BAR_HEIGHT > whiteboardContainerHeight;
  };

  if (!(isMobileVariant && isPosterVideo && !isVersionHistoryModeActive)) {
    return null;
  }

  return <PosterMobileBigSeekbar setVisibiltyHidden={hidePosterMobileBigSeekbar()} />;
}
